import { Injectable } from '@angular/core';
import 'navigator.locks';

@Injectable({
   providedIn: 'root',
})
export class TabSleepPreventionService {
   private static LOCK_NAME = 'samwinWebAgentTabSleepPrevention';

   // Promise holding the lock (here it is simply held forever)
   // resolving this Promise would release the Web Lock
   protected lockResolver: any;

   init(): void {
      // avoid TS2339 "Property 'x' does not exist on type 'Navigator'"
      const nav: any = navigator;
      if (!nav || !nav.locks || !nav.locks.request) {
         console.warn('Unable to set up tab sleep prevention - Web Locks not supported by browser');
         return;
      }

      console.trace(`Setting up tab sleep prevention, requesting Web Lock '${TabSleepPreventionService.LOCK_NAME}'`);
      const promise = new Promise<void>((res) => {
         this.lockResolver = res;
      });
      nav.locks.request(TabSleepPreventionService.LOCK_NAME, { mode: 'shared' }, () => {
         console.trace(`Tab sleep prevention set up, holding Web Lock '${TabSleepPreventionService.LOCK_NAME}'`);
         return promise;
      });
   }
}
